// Add this helper function
import axios from "axios";
import { REFRESH_TOKEN_KEY, TOKEN_KEY } from "./constants";

let refreshAbortController: AbortController | null = null;
let refreshPromise: Promise<void> | null = null;

export const refreshAuthToken = async () => {
  // If there's already a refresh in progress, wait for it
  if (refreshPromise) {
    console.log("Token refresh already in progress, waiting...");
    return refreshPromise;
  }

  // Cancel any existing refresh request
  if (refreshAbortController) {
    refreshAbortController.abort();
  }

  // Create new abort controller for this request
  refreshAbortController = new AbortController();

  // Create and store the refresh promise
  refreshPromise = fetchToken(refreshAbortController.signal)
    .catch((error) => {
      // Don't throw if the error is due to abortion
      if (
        error instanceof Error &&
        (error.name === "AbortError" || error.name === "CanceledError")
      ) {
        console.log("Previous refresh request was cancelled");
        return;
      }
      throw error;
    })
    .finally(() => {
      refreshAbortController = null;
      refreshPromise = null; // Clear the promise when done
    });

  return refreshPromise;
};

export const fetchToken = async (abortSignal?: AbortSignal) => {
  const axiosInstance = axios.create();
  const tokenRefreshResponse = await axiosInstance.post(
    `${import.meta.env.VITE_PUBLIC_BACKEND_API_URL}/auth/refresh`,
    {},
    {
      headers: {
        Authorization: "Bearer " + localStorage.getItem(REFRESH_TOKEN_KEY),
      },
      signal: abortSignal,
    }
  );
  localStorage.setItem(TOKEN_KEY, tokenRefreshResponse.data.token);
  localStorage.setItem(
    REFRESH_TOKEN_KEY,
    tokenRefreshResponse.data.refreshToken
  );
};
